import React from 'react';
import Notes from './Notes.jsx';

const LeadNotesIndex = () => {
    return (
        <div>
            <Notes context={"lead"} />
        </div>
    );
}

export default LeadNotesIndex;
